import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()({
  container: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
  },
})

const LoadingPage = ({ style }: { style?: React.CSSProperties }) => {
  const { classes } = useStyles()

  return (
    <div className={classes.container} data-cy="loading-page">
      <div className={classes.content}>
        <CircularProgress size={90} thickness={2} style={style} />
      </div>
    </div>
  )
}

export default LoadingPage
